export default "__VITE_ASSET__CNresm8___"